export const accountData = [
  // --- STRATEGIC 1:1 (Financial Services) ---
  {
    id: 100,
    name: "Vanguard",
    vertical: "Financial Services",
    region: "NAMER",
    tier: "Strategic 1:1",
    revenue: "$8.4M",
    owner: "Sarah Jenkins",
    renewal: "2026-06-30",
    propensity: "High",
    // Specific notes based on your input
    strategy:
      "Launch GenAI Academy org-wide. Alignment with CDAO & HR/L&D. Transition from foundational to role-specific development.",
    stakeholders:
      "CDAO, CHRO, CTO, Head of L&D, AI Steering Committee, Procurement",
    blockers:
      "Key contact (206A) transitioning roles; Need for admin customization in Degreed integration.",
    objectives:
      "Drive 'crew' adoption of GenAI Foundations & Leader adoption of 'Driving GenAI Change'.",
    metrics:
      "2400 learners progressing, 5000 enrollments, 1100+ users with 2+ hours.",
  },

  // --- STRATEGIC 1:1 (Tech/Software) ---
  {
    id: 200,
    name: "Nvidia",
    vertical: "Tech/Software",
    region: "NAMER",
    tier: "Strategic 1:1",
    revenue: "$5.2M",
    owner: "David Chen",
    renewal: "2026-04-15",
    propensity: "High",
    strategy:
      "Executive alignment on Deep Learning Institute partnership expansion.",
    stakeholders:
      "Jensen (CEO Office), VP Developer Relations, Head of AI Learning",
    blockers: "Awaiting new budget cycle for Q2 2026.",
    objectives: "Expand technical certification footprint.",
    metrics: "Pending Q1 review.",
  },

  // --- SCALE 1:FEW (Tech/Software) ---
  // List provided: ADP to Expedia Group
  ...[
    "ADP",
    "Pitney Bowes",
    "Shopify",
    "Databricks",
    "ByteDance",
    "Onsemi",
    "Agilent Technologies",
    "Benchmark Electronics",
    "Activision Blizzard",
    "Blue Yonder",
    "Netapp, Inc.",
    "Salesforce",
    "Unity Technologies",
    "Sony Corporation Of America",
    "Autodesk Inc",
    "Juniper Networks",
    "Seagate Technology",
    "Workday, Inc.",
    "HPE",
    "ServiceNow",
    "Adobe",
    "ThoughtWorks",
    "Bmc Software Inc.",
    "Globant",
    "Trend Micro",
    "NTT DATA",
    "Expedia Group",
  ].map((name, i) => ({
    id: 300 + i,
    name,
    vertical: "Tech/Software",
    region: "NAMER",
    tier: "Scale 1:Few",
    revenue: "$1.2M", // Placeholder avg
    owner: "Tech Major Accts Team",
    renewal: "2026-09-01",
    propensity: i < 5 ? "High" : "Medium", // Top 5 high propensity
    strategy: "Standardized technical upskilling tracks (Cloud/DevOps).",
    stakeholders: "CTO, VP Engineering, L&D Director",
    blockers: "Budget fragmentation across business units.",
    objectives: "Renew enterprise license; drive utilization >60%.",
    metrics: "Utilization rate, Skill assessments completed.",
  })),

  // --- SCALE 1:FEW (Financial Services) ---
  // List provided: Citi to Northern Trust
  ...[
    "Citi",
    "E*TRADE",
    "BGC Partners, Inc.",
    "UBS Americas Inc.",
    "PwC Canada",
    "Capital One Financial Corporation",
    "The Goldman Sachs Group Inc",
    "Morgan Stanley",
    "BlackRock",
    "TIAA",
    "Credit Suisse (Usa) Inc.",
    "BAIN CAPITAL PRIVATE EQUITY, LP",
    "Deutsche Bank America",
    "The Bank of New York Mellon Corporation",
    "State Street",
    "American Express",
    "T. Rowe Price",
    "PNC",
    "Edward D. Jones & Co.",
    "Paychex",
    "Synovus Financial",
    "Baker Tilly Canada",
    "Rocket Mortgage",
    "Visa",
    "Capital Group",
    "PayPal",
    "Fiserv",
    "The Charles Schwab Corporation",
    "Northern Trust Corp.",
  ].map((name, i) => ({
    id: 400 + i,
    name,
    vertical: "Financial Services",
    region: "NAMER",
    tier: "Scale 1:Few",
    revenue: "$950k", // Placeholder avg
    owner: "FinServ Major Accts Team",
    renewal: "2026-10-15",
    propensity: i < 5 ? "High" : "Medium",
    strategy: "Compliance training & Digital Transformation leadership.",
    stakeholders: "Chief Risk Officer, Head of Talent, Digital Transf. Lead",
    blockers: "Regulatory compliance review pending for new content.",
    objectives: "Expand into Wealth Management division.",
    metrics: "Completion rates for compliance tracks.",
  })),

  // --- HEALTHCARE (New for 2026 - Keeping minimal placeholders) ---
  {
    id: 500,
    name: "UnitedHealth Group",
    vertical: "Healthcare",
    region: "NAMER",
    tier: "Strategic 1:1",
    revenue: "$0",
    owner: "New Hire",
    renewal: "N/A",
    propensity: "High",
  },
  {
    id: 501,
    name: "CVS Health",
    vertical: "Healthcare",
    region: "NAMER",
    tier: "Scale 1:Few",
    revenue: "$0",
    owner: "New Hire",
    renewal: "N/A",
    propensity: "Medium",
  },
];
